import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { CurrencyActionsType } from '../actions/actions';
import { initialCurrencyState } from '../state/state';

const CurrencyReducer = (state = initialCurrencyState, actions: GeneralAction<CurrencyActionsType>) => {
    switch (actions.type) {
        case CurrencyActionsType.GET_CURRENCY:
            return { ...state, currencyLoading: true }
        case CurrencyActionsType.GET_CURRENCY_FAIL:
            return { ...state, currencyLoading: false, currencyError: actions.payload }
        case CurrencyActionsType.GET_CURRENCY_SUCCESS:
            return {...state, currencyLoading: true, data: actions.payload}
        default:
            return state;
    }
};

export default CurrencyReducer;
